module.exports = __webpack_public_path__ + "static/media/illustrations.7a67fbce.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductImagery/assets/illustrations.png
// module id = 505
// module chunks = 0